import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogContent,
  Backdrop,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { CloseSharp } from "@mui/icons-material";
import dowloadicon from "../../assets/images/dowload-black.png";
import { toLocalTime } from "../../helper/functions";
import { $crud } from "../../utils/CrudFactory";
import { BASE_URL } from "../../constants";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backdropFilter: "blur(2px)", // Adjust blur strength as needed
  },
  dialogPaper: {
    borderRadius: "0", // Set border radius to 0
    border: "1px solid #000",
  },
  textFieldRoot: {
    "& .MuiInputLabel-root": {
      color: "#8D8D8E !important", // Adding !important to ensure the color overrides
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "rgba(103, 60, 142, 1)", // Initial outlined border color
      },
      "&:hover fieldset": {
        borderColor: "rgba(103, 60, 142, 1)", // Change outlined border color on hover
      },
      "&.Mui-focused fieldset": {
        borderColor: "rgba(103, 60, 142, 1)", // Change outlined border color when focused
      },
    },
  },
}));
const OrderInvoiceModal = ({ onClose, open, order }) => {
  const classes = useStyles();
  const [invoices, setInvoices] = useState([]);

  async function handleDownload(invoice) {
    const response = await fetch(`${BASE_URL}clientInvoice/${invoice.invoice}`);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `Invoice-${invoice.clientStatementId}`;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  useEffect(() => {
    async function fetchInvoices() {
      try {
        const { data } = await $crud.retrieve("admin/order/all-invoices", {
          orderId: order?.orderId,
        });
        setInvoices(data?.invoices);
      } catch (e) {
        console.error(e);
      }
    }
    fetchInvoices();
  }, [order?.orderId]);

  return (
    <>
      <Backdrop className={classes.backdrop} open={open} />
      <Dialog
        open={open}
        onClose={onClose}
        sx={{ mx: "auto" }}
        // classes={{ paper: classes.dialogPaper }}
      >
        <DialogContent
          sx={{
            padding: "5px",
            width: "249px",
            paddingX: "10px",
            backgroundColor: "white",
            position: "relative",
            borderRadius: "12px",
          }}
        >
          <CloseSharp
            onClick={() => onClose()}
            sx={{
              width: "15px",
              height: "15px",
              color: "black",
              right: "10px",
              position: "absolute",
              cursor: "pointer",
            }}
          />
          <Box sx={{ width: "100%", height: "100%" }} mt={"20px"}>
            <Typography
              textAlign={"center"}
              fontWeight={"600"}
              fontSize={"12px"}
              color={"black"}
            >
              Invoices
            </Typography>
            <Typography
              fullWidth
              sx={{
                paddingX: "10px",
                padding: "5px",
                backgroundColor: "#683C8C !important",
                marginTop: "10px",
                fontSize: "14px",
                fontWeight: 600,
                borderRadius: "4px",
                color: "white",
                textAlign: "center",
              }}
            >
              {order.orderId}
            </Typography>
            {invoices.length > 0 ? (
              <Box
                px={"15px"}
                display={"flex"}
                flexDirection={"column"}
                gap="25px"
                mt={"10px"}
                sx={{ maxHeight: "75vh", overflowY: "auto" }}
              >
                {invoices.map((invoice, i) => (
                  <Box
                    key={i}
                    display={"flex"}
                    gap="25px"
                    alignItems={"center"}
                    justifyContent={"space-between"}
                  >
                    <Box display={"flex"} flexDirection={"column"} gap="3px">
                      <Typography fontSize={"10px"} fontWeight={600}>
                        {invoice.clientStatementId}
                      </Typography>
                      <Typography fontSize={"10px"} color={"black"}>
                        {toLocalTime(
                          invoice.createdAt,
                          "ddd,DD MMM YYYY, h:mm A"
                        )}
                      </Typography>
                    </Box>
                    {/.pdf/.test(invoice.invoice) ? (
                      <img
                        style={{ cursor: "pointer" }}
                        src={dowloadicon}
                        alt="download-icon"
                        onClick={() => handleDownload(invoice)}
                      />
                    ) : (
                      <Typography
                        sx={{
                          fontSize: "10px",
                        }}
                      >
                        🚫
                      </Typography>
                    )}
                  </Box>
                ))}
              </Box>
            ) : (
              <Typography
                mt={"10px"}
                sx={{ textAlign: "center", fontSize: "10px", color: "black" }}
              >
                No Invoices
              </Typography>
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default OrderInvoiceModal;
